<script lang="ts">
import { defineComponent } from 'vue';
import type { CreatePoolTypeCategory } from '@/types/pools';
import { mapActions, mapState } from 'pinia';
import { usePoolsStore } from '@/stores/pools';
import { validateNumber } from '@/components/pools/helpers';

export default defineComponent({
  name: 'categories-add',
  computed: {
    ...mapState(usePoolsStore, ['currentPoolTypeId']),
  },
  data() {
    return {
      newPoolTypeCategory: {} as CreatePoolTypeCategory,
    };
  },
  methods: {
    validateNumber,
    ...mapActions(usePoolsStore, ['fetchPoolTypeCategories', 'createPoolTypeCategory']),
    async createNewPoolTypeCategory() {
      return this.createPoolTypeCategory(this.currentPoolTypeId!, this.newPoolTypeCategory).then(() =>
        this.fetchPoolTypeCategories()
      );
    },
  },
});
</script>

<template>
  <tr>
    <td><i class="pi pi-file-plus" /></td>
    <td>
      <input
        type="number"
        @focusout="
          newPoolTypeCategory.voidedCount = validateNumber(newPoolTypeCategory.voidedCount)
        "
        v-model="newPoolTypeCategory.voidedCount"
        placeholder="Кол-во отмененных"
      />
    </td>
    <td>
      <input
        type="number"
        class="required"
        @focusout="
          newPoolTypeCategory.guessedCount = validateNumber(newPoolTypeCategory.guessedCount)!
        "
        v-model="newPoolTypeCategory.guessedCount"
        placeholder="Кол-во угаданных"
      />
    </td>
    <td>
      <input
        type="number"
        class="required"
        @focusout="
          newPoolTypeCategory.poolPercentage = validateNumber(newPoolTypeCategory.poolPercentage)!
        "
        v-model="newPoolTypeCategory.poolPercentage"
        placeholder="Процент от пула"
      />
    </td>
    <td>
      <input
        type="number"
        @focusout="
          newPoolTypeCategory.jackpotPercentage = validateNumber(
            newPoolTypeCategory.jackpotPercentage
          )
        "
        v-model="newPoolTypeCategory.jackpotPercentage"
        placeholder="Процент от джекпота"
      />
    </td>
    <td>
      <input
        type="number"
        class="required"
        @focusout="
          newPoolTypeCategory.sharePercentage = validateNumber(newPoolTypeCategory.sharePercentage)
        "
        v-model="newPoolTypeCategory.sharePercentage"
        placeholder="Процент перераспределения"
      />
    </td>
    <td>
      <i
        class="pi pi-plus-circle text-green-500 pt-1 cursor-pointer"
        @click="createNewPoolTypeCategory"
      />
    </td>
  </tr>
</template>

<style lang="scss" scoped>
input {
  @apply w-full bg-transparent focus:border-none focus:outline-dotted text-center placeholder:font-thin placeholder:italic py-2;
}

.required {
  @apply placeholder-yellow-500;
}
</style>
